<mat-sidenav-container class="example-container">
    <mat-sidenav mode="side" class="sidebar" opened>
        <h6 class="logo">S9</h6>
        <div class="description-logo">
            <p>Drivers</p>
        </div>
        <div class="truck-sidenav">
            <div [ngClass]="{'active': tripType=='-1'}" class="truck-sidenav-menu">
                <h2 (click)="getTripsList('-1')" routerLink="/adminsidebar/dashboard">Dashboard</h2>
            </div>
            <div [ngClass]="{'active': tripType=='trucks'}" class="truck-sidenav-menu" [matMenuTriggerFor]="menu">
                <h2 (click)="getTripsList('trucks')">Trucks</h2>
                <div class="dropdown">
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="getTripsList('trucks')">Trucks</button>
                        <button mat-menu-item (click)="getTripsList('truck-category')">Trucks Category</button>
                        <button mat-menu-item (click)="getTripsList('truck-type')">Trucks Type</button>
                    </mat-menu>
                </div>
            </div>
            <div [ngClass]="{'active': tripType=='drivers'}" class="truck-sidenav-menu">
                <h2 (click)="getTripsList('drivers')">Drivers</h2>
            </div>
            <div [ngClass]="{'active': tripType=='mapping'}" class="truck-sidenav-menu">
                <h2 (click)="getTripsList('mapping')">Mapping</h2>
            </div>
            <div [ngClass]="{'active': tripType=='driverOrder'}" class="truck-sidenav-menu">
                <h2 (click)="getTripsList('driverOrder')">Driver Order (Route)</h2>
            </div>
            <div [ngClass]="{'active': tripType=='tax'}" class="truck-sidenav-menu">
                <h2 (click)="getTripsList('tax')">Tax</h2>
            </div>
            <div [ngClass]="{'active': tripType=='gps'}" class="truck-sidenav-menu">
                <h2 (click)="getTripsList('gps')">GPS</h2>
            </div>
            <div [ngClass]="{'active': tripType=='documnets'}" class="truck-sidenav-menu">
                <h2 (click)="getTripsList('documnets')">Documents</h2>
            </div>
            <div [ngClass]="{'active': tripType=='trips'}" class="truck-sidenav-menu">
                <h2 (click)="getTripsList('trips')">Trips</h2>
            </div>
            <div [ngClass]="{'active': tripType=='payments'}" class="truck-sidenav-menu">
                <h2 (click)="getTripsList('payments')">Payments</h2>
            </div>
            <div [ngClass]="{'active': tripType=='track'}" class="truck-sidenav-menu">
                <h2 (click)="getTripsList('track')">Track</h2>
            </div>
            <div [ngClass]="{'active': tripType=='users'}" class="truck-sidenav-menu">
                <h2 (click)="getTripsList('users')">Users</h2>
            </div>
            <div [ngClass]="{'active': tripType=='web'}" class="truck-sidenav-menu">
                <h2 (click)="getTripsList('web')">Web Pages</h2>
            </div>
        </div>
    </mat-sidenav>
    <mat-sidenav-content class="mainContent">
        <div class="row m-0">
            <router-outlet></router-outlet>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>